import type { Stripe } from '@stripe/stripe-js';
import { createContext } from 'react';

export const StripeLoaderContext = createContext<PromiseLike<Stripe | null> | null>(null);
